module.exports = __webpack_public_path__ + "img/distribute-horizontal.5b3510a4.svg";